import { render, staticRenderFns } from "./DrugManufacturing.vue?vue&type=template&id=24a962d1&scoped=true"
import script from "./DrugManufacturing.vue?vue&type=script&lang=js"
export * from "./DrugManufacturing.vue?vue&type=script&lang=js"
import style0 from "./DrugManufacturing.vue?vue&type=style&index=0&id=24a962d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a962d1",
  null
  
)

export default component.exports